/** 
 * This is the apps entry point. 
 * Creates a div#root and renders the App via React
 * @module index
 * @see module:App
 */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const parent = document.createElement('div');
parent.setAttribute('id', 'root');
document.body.appendChild(parent);
ReactDOM.render(<App />, parent);